import { loadScript } from '../utils/script';
import {
  ThreeDsTypes,
  Either,
  Right,
  Left,
  Failure,
  Configurator,
} from 'types';

declare var PayThreeDSConnector: any;

export namespace Expedia {
  let connector = null;

  const libSource =
    'https://static.pay.expedia.com/3ds/1.3.65/pay-3ds-js-libs-connector.min.js';
  const integrity =
    'sha384-gYopPw6xE5DZwnZXGavkwnvs3NkDOobnHqjroUnSHpGXvs/J9xjHX/8aGzKtSgWI';
  const iFrameDOMId = 'threeDsIframe';
  const libUrl = 'https://static.pay.expedia.com';
  const iframeUrl = 'https://static.pay.expedia.com/3ds/threeDsIframe.html';
  const iframeUrlSandbox =
    'https://static.pay.expedia.com/3ds/sandboxThreeDsIframe.html';
  const referenceId = 1000;

  export const getIframeUrl = (): string => {
    const configurator = Configurator.builder();
    if (configurator) {
      return configurator.eps.useSandbox ? iframeUrlSandbox : iframeUrl;
    } else {
      return iframeUrl;
    }
  };

  export const fetchDependecy = async () => {
    try {
      await loadScript(libSource, integrity);
    } catch (e) {
      console.log(e);
    }
  };

  export const initConnector = async () => {
    if (connector) {
      return;
    } else {
      try {
        connector = await new PayThreeDSConnector.ThreeDSConnector(
          iFrameDOMId,
          libUrl,
        );

        console.log('PayThreeDSConnector initialized');
      } catch (e) {
        console.log(e);
      }
    }
  };

  export const setup = async (): Promise<
    Either<Failure.Absract, ThreeDsTypes.Meta>
  > => {
    try {
      if (!connector) {
        await initConnector();
      }

      console.log('PayThreeDSConnector setup');

      const result = await connector.setup({ referenceId: referenceId });

      console.log('PayThreeDSConnector setup result', result);

      return Right(result);
    } catch (e) {
      console.log(e);
      return Left(new Failure.RuntimeFailure());
    }
  };

  export const initSession = async (
    paymentSession: ThreeDsTypes.PaymentSession,
  ): Promise<Either<Failure.Absract, ThreeDsTypes.InitSessionResponse>> => {
    try {
      if (paymentSession.encodedConfig === null) {
        paymentSession.encodedConfig = undefined;
      }

      console.log(
        'PayThreeDSConnector initSession paymentSession',
        paymentSession,
      );

      const initSession = await connector.initSession({
        paymentSessionId: paymentSession.paymentSessionId,
        encodedInitConfig: paymentSession.encodedConfig,
      });

      console.log('PayThreeDSConnector initSession result', initSession);

      return Right(initSession);
    } catch (e) {
      return Left(new Failure.RuntimeFailure());
    }
  };

  export const challenge = async (
    paymentSession: ThreeDsTypes.PaymentSession,
  ): Promise<Either<Failure.Absract, ThreeDsTypes.InitSessionResponse>> => {
    try {
      paymentSession.encodedConfig = paymentSession.encodedConfig
        ? paymentSession.encodedConfig
            .replace(/\+/g, '-')
            .replace(/\//g, '_')
            .replace(/=+$/, '')
        : undefined;

      console.log(
        'PayThreeDSConnector challenge paymentSession',
        paymentSession,
      );

      const challenge = await connector.challenge({
        paymentSessionId: paymentSession.paymentSessionId,
        encodedChallengeConfig: paymentSession.encodedConfig,
      });

      console.log('PayThreeDSConnector challenge result', challenge);

      return Right(challenge);
    } catch (e) {
      return Left(new Failure.RuntimeFailure());
    }
  };

  export const destroy = () => {
    console.log('PayThreeDSConnector destroy');
    connector = null;
  };
}
